export default "__VITE_ASSET__dce95b5a__$_?nuxt_component=async&nuxt_component_name=SvgoSmallBlobsLight__"